import {
  GET_PROFILE,
  UPDATE_PROFILE,
  API_ERROR,
  UPDATE_PROFILE_SUCCESS,
  GET_PROFILE_SUCCESS,
  GET_ROLES,
  GET_ROLES_SUCCESS,
  UPDATE_PROFILE_META_TAGS,
  UPDATE_PROFILE_META_TAGS_SUCCESS,
  OPEN_CHANGE_PASSWORD_MODAL,
  HIDE_CHANGE_PASSWORD_MODAL,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILED,
  OPEN_CHANGE_PASSWORD_FAILURE_MODAL,
  HIDE_CHANGE_PASSWORD_FAILURE_MODAL,
  GET_EVENT_TEASER,
  GET_EVENT_TEASER_SUCCESS,
  GET_EVENT_TEASER_FAILED,
  RESET_EVENT_TEASER,
  DELETE_ADMIN_USER,
  DELETE_ADMIN_USER_SUCCESS,
  DELETE_ADMIN_USER_FAILED,
  CREATE_ADMIN_USER,
  CREATE_ADMIN_USER_SUCCESS,
  CREATE_ADMIN_USER_FAILED,
  UPDATE_ADMIN_USER,
  UPDATE_ADMIN_USER_SUCCESS,
  UPDATE_ADMIN_USER_FAILED,
  GET_USER_PROFILE,
  GET_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE_FAILED,
  RESET_USER_PROFILE,
  OPEN_PWD_SECURITY_CHECK_MODAL,
  HIDE_PWD_SECURITY_CHECK_MODAL,
  PWD_SECURITY_CHECK,
  PWD_SECURITY_CHECK_SUCCESS,
  PWD_SECURITY_CHECK_FAILED,
} from "store/profile/actionTypes"

export const getProfile = params => ({ type: GET_PROFILE, payload: { params } })
export const getProfileSuccess = values => ({
  type: GET_PROFILE_SUCCESS,
  payload: values,
})

export const updateProfile = values => ({
  type: UPDATE_PROFILE,
  payload: { values },
})
export const updateProfileSuccess = values => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: values,
})

export const updateProfileMetaTags = values => ({
  type: UPDATE_PROFILE_META_TAGS,
  payload: values,
})
export const updateProfileMetaTagsSuccess = values => ({
  type: UPDATE_PROFILE_META_TAGS_SUCCESS,
  payload: values,
})

export const getRoles = () => ({ type: GET_ROLES, payload: {} })
export const resetRoles = () => ({ type: GET_ROLES_SUCCESS, payload: [] })
export const getRolesSuccess = roles => ({
  type: GET_ROLES_SUCCESS,
  payload: roles,
})

export const apiError = values => ({ type: API_ERROR })

export const openChangePasswordModal = () => ({
  type: OPEN_CHANGE_PASSWORD_MODAL,
  payload: {},
})

export const hideChangePasswordModal = () => ({
  type: HIDE_CHANGE_PASSWORD_MODAL,
  payload: {},
})

export const changePassword = params => ({
  type: CHANGE_PASSWORD,
  payload: params,
})

export const changePasswordSuccess = response => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: response,
})

export const changePasswordFailed = error => ({
  type: CHANGE_PASSWORD_FAILED,
  payload: error,
})

export const openChangePasswordFailureModal = () => ({
  type: OPEN_CHANGE_PASSWORD_FAILURE_MODAL,
  payload: {},
})

export const hideChangePasswordFailureModal = () => ({
  type: HIDE_CHANGE_PASSWORD_FAILURE_MODAL,
  payload: {},
})

export const getEventTeaser = params => ({
  type: GET_EVENT_TEASER,
  payload: params,
})

export const getEventTeaserSuccess = response => ({
  type: GET_EVENT_TEASER_SUCCESS,
  payload: response,
})

export const resetEventTeaser = () => ({
  type: RESET_EVENT_TEASER,
  payload: {},
})

export const deleteAdminUser = params => ({
  type: DELETE_ADMIN_USER,
  payload: params,
})

export const deleteAdminUserSuccess = response => ({
  type: DELETE_ADMIN_USER_SUCCESS,
  payload: response,
})

export const deleteAdminUserFailed = error => ({
  type: DELETE_ADMIN_USER_FAILED,
  payload: error,
})

export const createAdminUser = params => ({
  type: CREATE_ADMIN_USER,
  payload: params,
})

export const createAdminUserSuccess = response => ({
  type: CREATE_ADMIN_USER_SUCCESS,
  payload: response,
})

export const createAdminUserFailed = error => ({
  type: CREATE_ADMIN_USER_FAILED,
  payload: error,
})

export const updateAdminUser = params => ({
  type: UPDATE_ADMIN_USER,
  payload: params,
})

export const updateAdminUserSuccess = response => ({
  type: UPDATE_ADMIN_USER_SUCCESS,
  payload: response,
})

export const updateAdminUserFailed = error => ({
  type: UPDATE_ADMIN_USER_FAILED,
  payload: error,
})

export const getUserProfile = params => ({
  type: GET_USER_PROFILE,
  payload: params,
})

export const getUserProfileSuccess = response => ({
  type: GET_USER_PROFILE_SUCCESS,
  payload: response,
})

export const getUserProfileFailed = error => ({
  type: GET_USER_PROFILE_FAILED,
  payload: error,
})

export const resetUserProfile = () => ({
  type: RESET_USER_PROFILE,
  payload: {},
})

export const openPwdSecurityCheckModal = () => ({
  type: OPEN_PWD_SECURITY_CHECK_MODAL,
  payload: {},
})

export const hidePwdSecurityCheckModal = () => ({
  type: HIDE_PWD_SECURITY_CHECK_MODAL,
  payload: {},
})

export const pwdSecurityCheck = params => ({
  type: PWD_SECURITY_CHECK,
  payload: params,
})

export const pwdSecurityCheckSuccess = response => ({
  type: PWD_SECURITY_CHECK_SUCCESS,
  payload: response,
})

export const pwdSecurityCheckFailed = error => ({
  type: PWD_SECURITY_CHECK_FAILED,
  payload: error,
})
